import { cmdId, keyBlocklyXml } from "./consts";
//import {
//    parseCode
//} from './utils/js2blocks';
import BlocklyEditor from "./blocklyEditor";

export default (editor, opts = {}) => {
  const cm = editor.Commands;
  const md = editor.Modal;
  const domc = editor.Components;
  const {
    modalTitle,
    codeViewOptions,
    commandBlocklyScript,
    blocklyOptions,
    blocklyTypesSupport,
    toolbarIcon,
    onRun,
    onError,
    starter,
  } = opts;

  let blocklyEditor = null;
  let content = null;
  let initialComponentValue = "";
  const projectId = window.location.search.split("=")[1];

  const appendToContent = (target, content) => {
    if (content instanceof HTMLElement) {
      target.appendChild(content);
    } else if (content) {
      target.insertAdjacentHTML("beforeend", content);
    }
  };

  //Global variable to store compiled blockly code
  window.componentBlocklyCode = {};

  // Add icons to specified component types
  blocklyTypesSupport &&
    blocklyTypesSupport.forEach((type) => {
      const typeOpt = domc.getType(type).model;
      domc.addType(type, {
        model: {
          initToolbar() {
            typeOpt.prototype.initToolbar.apply(this, arguments);
            const tb = this.get("toolbar");
            const tbExists = tb.some((item) => item.command === cmdId);

            if (!tbExists) {
              tb.unshift({
                command: cmdId,
                label: toolbarIcon,
                ...opts.toolbarBtnBlockly,
              });
              this.set("toolbar", tb);
            }
          },
        },
      });
    });

  // Add the blockly command
  cm.add(cmdId, {
    keyBlocklyXml,

    async run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const target = this.target;

      let projectPages = await this.fetchProjectPages();

      console.log("projectPages::::::::::commands::::", projectPages);

      console.log("cmdId::::::::::");

      if (target && projectPages) {
        this.showCustomCode(target, projectPages);
        // this.appendToggleButton(); // Add the toggle button after the content is initialized
      }
    },

    fetchProjectPages() {
      return new Promise((resolve, reject) => {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        // const apihost = "http://127.0.0.1:8085/";

        // const apihost = "https://backend1.redsling.com/";
        // const apihost = process.env.REACT_APP_API_HOST;

        const apihost = "https://staging-backend1.redsling.com/";

        // const apihost = "http://3.210.40.119:7500/";

        fetch(`${apihost}pages/projectPage/${projectId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            try {
              const blockTypes = data.pages.map((x) => ({
                name: x.name,
                id: x._id,
              }));

              resolve(blockTypes);
            } catch (e) {
              console.error(e);
            }
          })
          .catch((error) => {
            console.error("API call error:", error);
            reject(error);
          });
      });
    },

    stop(editor) {
      //blocklyEditor && blocklyEditor.hide();
      blocklyEditor.workspace.clear();
      md.close();
    },

    // to handle copy-pasting of LB logic
    addClipboardContextMenu(workspace) {
      const showNotification = (message, type = "success") => {
        const toast = document.createElement("div");
        toast.innerText = message;
        toast.style.position = "fixed";
        toast.style.top = "20px";
        toast.style.right = "20px";
        toast.style.zIndex = 9999;
        toast.style.padding = "10px 16px";
        toast.style.borderRadius = "6px";
        toast.style.fontSize = "14px";
        toast.style.fontFamily = "sans-serif";
        toast.style.color = "#fff";
        toast.style.backgroundColor =
          type === "success" ? "#28a745" : "#dc3545";
        toast.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.15)";
        toast.style.opacity = "0";
        toast.style.transition = "opacity 0.3s ease";

        document.body.appendChild(toast);

        // Trigger fade-in
        requestAnimationFrame(() => {
          toast.style.opacity = "1";
        });

        // Remove after 3s
        setTimeout(() => {
          toast.style.opacity = "0";
          setTimeout(() => toast.remove(), 300);
        }, 4000);
      };

      // ORIGINAL FUNCTION to copy entire workspace
      // const copyHandler = async () => {
      //   const topBlocks = workspace.getTopBlocks(false);
      //   if (topBlocks.length) {
      //     const xmlDom = Blockly.utils.xml.createElement('xml');

      //     for (const block of topBlocks) {
      //       const blockDom = Blockly.Xml.blockToDom(block, true);
      //       xmlDom.appendChild(blockDom);
      //     }

      //     const xmlText = Blockly.utils.xml.domToText(xmlDom);

      //     try {
      //       await navigator.clipboard.writeText(xmlText);
      //       console.log("Copied blocks to clipboard");
      //     } catch (err) {
      //       console.error("Failed to copy:", err);
      //     }
      //   }
      // };

      // function to copy selected blocks
      const copyHandler = async (scope) => {
        const block = scope.block;
        if (block) {
          const xmlDom = Blockly.utils.xml.createElement("xml");
          const blockDom = Blockly.Xml.blockToDom(block, true);
          xmlDom.appendChild(blockDom);
          const xmlText = Blockly.utils.xml.domToText(xmlDom);
          try {
            await navigator.clipboard.writeText(xmlText);
            console.log("Copied selected block to clipboard");
            showNotification("Copied selected block stack.", "success");
          } catch (err) {
            console.error("Failed to copy:", err);
            showNotification("Failed to copy", "error");
          }
        } else {
          console.warn("No block context available for copy");
        }
      };

      const pasteHandler = async () => {
        try {
          const xmlText = await navigator.clipboard.readText();
          const xml = Blockly.utils.xml.textToDom(xmlText);
          Blockly.Xml.domToWorkspace(xml, workspace);
          console.log("Pasted blocks from clipboard");
          showNotification("Pasted selected block stack.", "success");
        } catch (err) {
          console.error("Failed to paste:", err);
          showNotification(
            "Failed to paste as the selected stack contains a block with no reference in the UI",
            "error"
          );
        }
      };

      // Register copy
      if (!Blockly.ContextMenuRegistry.registry.getItem("copyXmlToClipboard")) {
        Blockly.ContextMenuRegistry.registry.register({
          id: "copyXmlToClipboard",
          weight: 210,
          displayText: () => "Copy Block Stack from Selection",
          preconditionFn: (scope) => "enabled",
          callback: copyHandler,
          scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
        });
      }

      // Register paste
      if (
        !Blockly.ContextMenuRegistry.registry.getItem("pasteXmlFromClipboard")
      ) {
        Blockly.ContextMenuRegistry.registry.register({
          id: "pasteXmlFromClipboard",
          weight: 211,
          displayText: () => "Paste Block Stack",
          preconditionFn: (scope) => "enabled",
          callback: pasteHandler,
          scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
        });
      }

      // Register keyboard shortcut listeners
      // document.addEventListener('keydown', async (event) => {
      //   const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      //   const copyKey = isMac ? event.metaKey : event.ctrlKey;

      //   // Copy: Ctrl/Cmd + C
      //   if (copyKey && event.key === 'c') {
      //     event.preventDefault();
      //     await copyHandler();
      //   }

      //   // Paste: Ctrl/Cmd + V
      //   if (copyKey && event.key === 'v') {
      //     event.preventDefault();
      //     await pasteHandler();
      //   }
      // });

      // document.addEventListener('keydown', async (event) => {
      //   const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      //   const copyKey = isMac ? event.metaKey : event.ctrlKey;

      //   const workspace = Blockly.getMainWorkspace();
      //   const selectedBlock = Blockly.selected;

      //   // Copy (Ctrl/Cmd + C)
      //   if (copyKey && event.key.toLowerCase() === 'c') {
      //     event.preventDefault();
      //     if (selectedBlock) {
      //       const xmlDom = Blockly.utils.xml.createElement('xml');
      //       const blockDom = Blockly.Xml.blockToDom(selectedBlock, true);
      //       xmlDom.appendChild(blockDom);
      //       const xmlText = Blockly.utils.xml.domToText(xmlDom);
      //       try {
      //         await navigator.clipboard.writeText(xmlText);
      //         console.log("Copied selected block to clipboard via keyboard");
      //       } catch (err) {
      //         console.error("Clipboard copy failed:", err);
      //       }
      //     }
      //   }

      //   // Paste (Ctrl/Cmd + V)
      //   if (copyKey && event.key.toLowerCase() === 'v') {
      //     event.preventDefault();
      //     try {
      //       const xmlText = await navigator.clipboard.readText();
      //       const xml = Blockly.utils.xml.textToDom(xmlText);
      //       Blockly.Xml.domToWorkspace(xml, workspace);
      //       console.log("Pasted block from clipboard via keyboard");
      //     } catch (err) {
      //       console.error("Clipboard paste failed:", err);
      //     }
      //   }
      // });
    },

    /**
     * Method which tells how to show the custom code
     * @param  {Component} target
     */
    showCustomCode(target, projectPages) {
      const { editor, options } = this;
      const title = options.title || "redSling";
      if (!content) content = this.getContent();
      const code = target.getScriptString();
      md.open({
        title,
        content,
      })
        .getModel()
        .once("change:open", () => editor.stopCommand(this.id));
      //? mount code editors
      if (!blocklyEditor) {
        blocklyEditor = new BlocklyEditor(
          content.querySelector("#blockly"),
          blocklyOptions,
          editor,
          projectPages,
          projectId
        );
        blocklyEditor.workspace.addChangeListener(() => this.updateWorkspace());

        // Add your custom copy/paste handlers
        this.addClipboardContextMenu(blocklyEditor.workspace);
      }

      console.log("target Blockly check", target);

      let xml;

      // if (target.attributes.tagName === "input") {
      //   xml =
      //     target.get(keyBlocklyXml) ||
      //     `<xml xmlns="https://developers.google.com/blockly/xml"><block type="bi_var" id="OHq;p^O:()AR3;aG%CwD" x="90" y="30"><field name="var_type">let</field><field name="var">el</field><value name="val"><block type="bi_var_name" id="Je,,~AE%W2MCRA?7u.^0"><field name="NAME">${target.view.$el[0].value}</field></block></value></block></xml>`;
      // } else if (target.attributes.tagName === "button") {
      //   xml =
      //     target.get(keyBlocklyXml) ||
      //     `<xml xmlns="https://developers.google.com/blockly/xml"><block type="bi_var" id="OHq;p^O:()AR3;aG%CwD" x="90" y="30"><field name="var_type">let</field><field name="var">el</field><value name="val"><block type="bi_var_name" id="Je,,~AE%W2MCRA?7u.^0"><field name="NAME">${target.view.$el[0].textContent}</field></block></value></block></xml>`;
      // } else if (target.attributes.tagName === "ion-input") {
      //   xml =
      //     target.get(keyBlocklyXml) ||
      //     `<xml xmlns="https://developers.google.com/blockly/xml"><block type="bi_var" id="OHq;p^O:()AR3;aG%CwD" x="90" y="30"><field name="var_type">let</field><field name="var">el</field><value name="val"><block type="bi_var_name" id="Je,,~AE%W2MCRA?7u.^0"><field name="NAME">${target.view.$el[0].textContent}</field></block></value></block></xml>`;
      // } else if (target.attributes.tagName === "ion-toggle") {
      //   xml =
      //     target.get(keyBlocklyXml) ||
      //     `<xml xmlns="https://developers.google.com/blockly/xml"><block type="bi_var" id="OHq;p^O:()AR3;aG%CwD" x="90" y="30"><field name="var_type">let</field><field name="var">el</field><value name="val"><block type="bi_var_name" id="Je,,~AE%W2MCRA?7u.^0"><field name="NAME">${target.view.$el[0].value}</field></block></value></block></xml>`;
      // } else if (target.attributes.tagName === "input-select") {
      //   xml =
      //     target.get(keyBlocklyXml) ||
      //     `<xml xmlns="https://developers.google.com/blockly/xml"><block type="bi_var" id="OHq;p^O:()AR3;aG%CwD" x="90" y="30"><field name="var_type">let</field><field name="var">el</field><value name="val"><block type="bi_var_name" id="Je,,~AE%W2MCRA?7u.^0"><field name="NAME">${target.view.$el[0].firstChildElement.value}</field></block></value></block></xml>`;
      // } else {
      //   xml =
      //     target.get(keyBlocklyXml) ||
      //     `<xml xmlns="https://developers.google.com/blockly/xml"><block type="bi_var" id="OHq;p^O:()AR3;aG%CwD" x="90" y="30"><field name="var_type">let</field><field name="var">el</field><value name="val"><block type="bi_var_name" id="Je,,~AE%W2MCRA?7u.^0"><field name="NAME">${target.view.$el[0].textContent}</field></block></value></block></xml>`;
      // }

      if (target.attributes.tagName === "input") {
        xml =
          target.get(keyBlocklyXml) ||
          `
            <xml xmlns="https://developers.google.com/blockly/xml">
              <block type="bi_comment" x="50" y="50">
                <field name="TEXT">Workspace is ready. Add your blocks here.</field>
              </block>
            </xml>
        `;
      } else if (target.attributes.tagName === "button") {
        xml =
          target.get(keyBlocklyXml) ||
          `
              <xml xmlns="https://developers.google.com/blockly/xml">
                <block type="bi_comment" x="50" y="50">
                  <field name="TEXT">Workspace is ready. Add your blocks here.</field>
                </block>
              </xml>
          `;
      } else if (target.attributes.tagName === "ion-input") {
        xml =
          target.get(keyBlocklyXml) ||
          `
              <xml xmlns="https://developers.google.com/blockly/xml">
                <block type="bi_comment" x="50" y="50">
                  <field name="TEXT">Workspace is ready. Add your blocks here.</field>
                </block>
              </xml>
          `;
      } else if (target.attributes.tagName === "ion-toggle") {
        xml =
          target.get(keyBlocklyXml) ||
          `
              <xml xmlns="https://developers.google.com/blockly/xml">
                <block type="bi_comment" x="50" y="50">
                  <field name="TEXT">Workspace is ready. Add your blocks here.</field>
                </block>
              </xml>
          `;
      } else if (target.attributes.tagName === "input-select") {
        xml =
          target.get(keyBlocklyXml) ||
          `
              <xml xmlns="https://developers.google.com/blockly/xml">
                <block type="bi_comment" x="50" y="50">
                  <field name="TEXT">Workspace is ready. Add your blocks here.</field>
                </block>
              </xml>
          `;
      } else {
        xml =
          target.get(keyBlocklyXml) ||
          `
              <xml xmlns="https://developers.google.com/blockly/xml">
                <block type="bi_comment" x="50" y="50">
                  <field name="TEXT">Workspace is ready. Add your blocks here.</field>
                </block>
              </xml>
          `;
      }

      //(code && parseCode(code)) || starter;
      // Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(xml), blocklyEditor.workspace);

      Blockly.Variables.allUsedVarModels_ = [];
      console.log("Blockly::::::::", Blockly);
      console.log(
        "Blockly.Variables.allUsedVarModels_",
        Blockly.Variables.allUsedVarModels_
      );

      // blocklyEditor.workspace.clear();
      Blockly.Xml.domToWorkspace(
        Blockly.utils.xml.textToDom(xml),
        blocklyEditor.workspace
      );
    },

    /**
     * Custom pre-content. Can be a simple string or an HTMLElement
     */
    getPreContent() {},

    /**
     * Custom post-content. Can be a simple string or an HTMLElement
     */
    getPostContent() {
      const postContent = document.createElement("div");
      postContent.id = "code-viewer";
      const codeViewer = this.getCodeViewer();
      codeViewer.refresh();
      setTimeout(() => codeViewer.focus(), 0);
      postContent.appendChild(codeViewer.getElement());

      console.log("postContent from LB:::::::::", postContent);

      return postContent; //blockly el
    },

    /**
     * Get all the content for the custom code
     * @return {HTMLElement}
     */
    getContent() {
      const { editor } = this;
      const content = document.createElement("div");
      const blocklyCont = document.createElement("div");
      blocklyCont.id = "blockly-cont";
      blocklyCont.innerHTML = `<div id="blockly" style="width:100%;height:500px;color:black"></div>`;
      const pfx = editor.getConfig("stylePrefix");
      content.className = `${pfx}inject-logic`;
      appendToContent(content, this.getPreContent());
      content.appendChild(blocklyCont);
      appendToContent(content, this.getPostContent());
      appendToContent(content, this.getContentActions());
      console.log("content from LB:::::::::", content);

      return content;
    },

    /**
     * Get the actions content. Can be a simple string or an HTMLElement
     * @return {HTMLElement|String}
     */
    getContentActions() {
      const { editor } = this;
      const actions = document.createElement("div");
      actions.id = "actns";
      actions.style =
        "position:absolute;bottom:auto;top:0;bottom:0;right:5%;z-index:2;width:max-content;display:flex;align-items:center;justify-content:flex-end;column-gap:20%";
      const btn = document.createElement("button");
      const pfx = editor.getConfig("stylePrefix");
      btn.innerHTML = opts.buttonLabel;
      btn.className = `${pfx}btn-prim ${pfx}btn-save__inject-logic`;
      btn.style =
        "background-color:#4caf50;border-radius:5px;padding:10% 15% 10% 15%;color:white;cursor:pointer";
      btn.onclick = () => this.handleSave();

      const runLogic = document.createElement("div");
      runLogic.id = "logic-toolbar";
      runLogic.className = "fa fa-bug";
      // runLogic.style = "margin:5px;padding:10px;background:rgba(0,0,0,0.2);border-radius:3px;border:1px solid rgba(0,0,0,0.2);cursor:pointer";
      runLogic.style =
        "background-color:lightgray;border-radius:5px;padding:17% 20% 17% 20%;color:white;cursor:pointer";
      runLogic.onclick = () => this.runCode();

      actions.appendChild(runLogic);
      actions.appendChild(btn);
      console.log("actions from LB:::::::::", actions);

      // Function to append actions to the 'gjs-mdl-header' once it's rendered
      const appendActionsToModalHeader = () => {
        const mdlHeader = document.querySelector(".gjs-mdl-header");

        if (mdlHeader) {
          mdlHeader.style.position = "relative";
          mdlHeader.appendChild(actions);
          console.log("Appended actions to 'gjs-mdl-header'.");
        } else {
          console.error("'gjs-mdl-header' not found in the DOM.");
        }
      };

      // to only append elements to the modal that have LB inside them
      editor.on("modal", (props) => {
        if (md && md.isOpen()) {
          // Check if there is any div with class 'gjs-inject-logic' inside 'gjs-mdl-content'
          const mdlContent = document.querySelector(".gjs-mdl-content");
          const mdlHeader = document.querySelector(".gjs-mdl-header");
          const hasInjectLogic = mdlContent.querySelector(".gjs-inject-logic");

          if (hasInjectLogic) {
            // Use setTimeout to ensure modal is fully rendered before appending
            setTimeout(appendActionsToModalHeader, 100); // Adjust timeout if needed
          } else {
            const actions = mdlHeader.querySelector("#actns");
            if (actions) actions.remove();
          }
        }
      });

      return actions;
    },

    getResultFromBlockly() {
      const workspace = blocklyEditor.workspace;
      console.log("workspace inside blockly", workspace);
      const javascriptCode = Blockly.JavaScript.workspaceToCode(workspace);
      console.log("js code inside blockly", javascriptCode);

      try {
        // Execute the JavaScript code using eval
        const result = eval(javascriptCode);
        console.log("result inside blockly1", result);
        return result;
      } catch (error) {
        // Handle any errors that may occur during execution
        console.error("Error executing Blockly code:", error);
        return null; // Return null or handle the error as needed
      }
    },

    // function to handle highlighting of component with LB logic
    componentHighlight(target) {
      const componentId = target.get("attributes").id;
      console.log("Component ID", componentId);

      // Get the stored blockly code for this specific component
      const blockly_code = window.componentBlocklyCode[componentId] || "";
      console.log(
        "Checking blockly code for component:",
        componentId,
        blockly_code
      );

      // Check if component has only starter code or is empty
      const hasOnlyStarterCode =
        !blockly_code ||
        blockly_code.trim() === "" ||
        blockly_code.trim().startsWith("let el = ");

      const currentUrl = window.location.href;
      // const pageId = currentUrl.split("/editor/")[1].split("?")[0];
      const pageId = currentUrl.includes("/editor/")
        ? currentUrl.split("/editor/")[1].split("?")[0]
        : "";

      const existingData = JSON.parse(
        sessionStorage.getItem("lb_instance_ref") || "{}"
      );

      const pageKey = `page_id_${pageId}`;

      if (!existingData[pageKey]) {
        existingData[pageKey] = [];
      }

      const targetEl = target.getEl();

      console.log("@blockly_code", blockly_code);

      if (!hasOnlyStarterCode) {
        console.log("@!hasOnlyStarterCode", hasOnlyStarterCode);
        // Component has meaningful logic - add to storage and highlight
        if (!existingData[pageKey].includes(componentId)) {
          existingData[pageKey].push(componentId);
        }
        targetEl.style.outline = "2px solid #39FF14";
      } else {
        console.log("@!hasOnlyStarterCode!", hasOnlyStarterCode);
        // Component has no meaningful logic - remove from storage and remove highlight
        const index = existingData[pageKey].indexOf(componentId);
        if (index !== -1) {
          existingData[pageKey].splice(index, 1);
          console.log(
            `Removed component ${componentId} from storage - logic cleared`
          );
        }
        targetEl.style.outline = "none";
      }

      // Save updated storage regardless of whether we added or removed
      sessionStorage.setItem("lb_instance_ref", JSON.stringify(existingData));
    },

    /**
     * Handle the main save task
     */
    handleSave() {
      const { editor, target } = this;
      // console.log("script from LB:::::::::", target.get("script"));
      // console.log(
      //   "keyBlocklyXml script from LB:::::::::",
      //   target.get(keyBlocklyXml)
      // );

      try {
        // window.editor = editor;

        // blocklyEditor.workspace.clear();
        const code = this.getCodeViewer().getContent();
        Function('"use strict";' + code)();

        const currentUrl = window.location.href;
        if (target && currentUrl.includes("/editor/")) {
          this.componentHighlight(target);
        }

        console.log("code inside blockly", typeof code);
        const xml = Blockly.Xml.workspaceToDom(blocklyEditor.workspace);
        console.log("Blockly.javascript", Blockly.javascript);
        console.log("xml inside blockly", xml);
        console.log("target inside blockly", target);

        const wrappedCode = `
          // SPACE_TO_AVOID_ADDITIONAL_PARENTHESIS
          ${code}
        `;

        // function findComponentsByTypeRecursive(
        //   rootComponent,
        //   type,
        //   foundComponents = []
        // ) {
        //   if (rootComponent.get("type") === type) {
        //     foundComponents.push(rootComponent);
        //   }

        //   const components = rootComponent.get("components");

        //   if (components) {
        //     components.forEach((childComponent) => {
        //       findComponentsByTypeRecursive(
        //         childComponent,
        //         type,
        //         foundComponents
        //       );
        //     });
        //   }

        //   return foundComponents;
        // }

        // function findComponentsByType(type) {
        //   const allComponents = window.top.editor.DomComponents.getComponents();
        //   const foundComponents = [];
        //   allComponents.forEach((rootComponent) => {
        //     findComponentsByTypeRecursive(rootComponent, type, foundComponents);
        //   });
        //   return foundComponents;
        // }
        // const componentTypeToFind = "custom-table-container";
        // const foundComponents = findComponentsByType(componentTypeToFind);
        // if (foundComponents.length > 0) {
        //   let barChartCompInstance = foundComponents[0];
        //   barChartCompInstance.attributes.script = null;
        // } else {
        //   console.log("No  components found");
        // }

        target.set("script", wrappedCode);
        target.set(keyBlocklyXml, Blockly.Xml.domToText(xml));

        const blocklyResult = this.getResultFromBlockly();

        editor.Modal.close();
      } catch (err) {
        console.error("Error in Blockly logic:", err);
        onError && onError(err);
      }
    },

    /**
     * Return the code viewer instance
     * @return {CodeViewer}
     */
    getCodeViewer() {
      const { editor } = this;

      if (!this.codeViewer) {
        this.codeViewer = editor.CodeManager.createViewer({
          codeName: "javascript",
          theme: "hopscotch",
          readOnly: 1,
          autoBeautify: 1,
          ...codeViewOptions,
        });
      }

      return this.codeViewer;
    },

    /**
     * Toggle between blockly and code viewer
     */
    toggleCodeViewer() {
      const blocklyStyle = content.querySelector("#blockly").style;
      const codeViewerStyle = content.querySelector("#code-viewer").style;
      // const hidden = blocklyStyle.height == "0px" || blocklyStyle.height == "0";

      // Check the current display state of the code viewer
      const hidden = codeViewerStyle.display === "none";

      if (hidden) {
        // blocklyStyle.height = "500px";
        codeViewerStyle.display = "block";
      } else {
        // blocklyStyle.height = "0";
        codeViewerStyle.display = "none";
      }
    },

    /**
     * Append the toggle button dynamically, only if 'gjs-inject-logic' exists inside 'gjs-mdl-content'
     */
    appendToggleButton() {
      const mdlContent = document.querySelector(".gjs-mdl-content");

      if (!mdlContent) {
        console.error("Could not find .gjs-mdl-content element.");
        return;
      }

      // Check if there is any div with class 'gjs-inject-logic' inside 'gjs-mdl-content'
      const hasInjectLogic = mdlContent.querySelector(".gjs-inject-logic");

      if (!hasInjectLogic) {
        console.warn(
          "No 'gjs-inject-logic' found inside '.gjs-mdl-content'. Toggle button will not be appended."
        );
        return;
      }

      // Check if the button already exists
      const existingBtn = mdlContent.querySelector(".toggle-code-viewer-btn");
      if (existingBtn) return;

      // Make gjs-mdl-content position relative
      mdlContent.style.position = "relative";

      // Create the toggle button
      const toggleBtn = document.createElement("button");
      toggleBtn.classList.add("toggle-code-viewer-btn");
      toggleBtn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="white" class="bi bi-chevron-expand" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708m0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708"/> </svg>';
      toggleBtn.style.position = "absolute";
      toggleBtn.style.bottom = "2%";
      toggleBtn.style.right = "2%";
      toggleBtn.style.padding = "inherit";
      toggleBtn.style.backgroundColor = "#4CAF50";
      toggleBtn.style.color = "white";
      toggleBtn.style.border = "none";
      toggleBtn.style.cursor = "pointer";
      toggleBtn.style.fontSize = "1vw";
      toggleBtn.style.borderRadius = "5px";

      // Hover effect for the button
      toggleBtn.onmouseover = () => {
        toggleBtn.style.backgroundColor = "#45a049";
        toggleBtn.style.zIndex = "9999"; // Bring to front
      };
      toggleBtn.onmouseout = () => {
        toggleBtn.style.backgroundColor = "#4CAF50";
        toggleBtn.style.zIndex = ""; // Reset to original z-index (back to normal flow)
      };

      // Add click event to toggle the viewer
      toggleBtn.addEventListener("click", () => this.toggleCodeViewer());

      // to only append elements to the modal that have LB inside them
      editor.on("modal", (props) => {
        if (md && md.isOpen()) {
          // Check if there is any div with class 'gjs-inject-logic' inside 'gjs-mdl-content'
          const hasInjectLogic = mdlContent.querySelector(".gjs-inject-logic");

          if (hasInjectLogic) {
            // Append the button to the gjs-mdl-content div
            mdlContent.appendChild(toggleBtn);
            // console.log("appended");
          } else {
            // console.log("not in lb modal");
            const existingBtn = mdlContent.querySelector(
              ".toggle-code-viewer-btn"
            );
            if (existingBtn) existingBtn.remove();
            // console.log("removed");
          }
        }
      });

      // Hide the code viewer by default
      const codeViewer = mdlContent.querySelector("#code-viewer");
      if (codeViewer) {
        codeViewer.style.display = "none"; // Set code viewer to be hidden by default
      }
    },

    /**
     * Update code when blocks change
     */
    updateWorkspace(e) {
      var workspaceContainer = blocklyEditor.workspace.getBubbleCanvas();
      workspaceContainer.style.opacity = 0.5;
      const blockly_code = Blockly.JavaScript.workspaceToCode(
        Blockly.mainWorkspace
      );

      // console.log("blockly_code from LB:::::::::", blockly_code);

      // Store the blockly code for the current component for highlighting
      const currentComponent = editor.getSelected();
      if (currentComponent) {
        const componentId = currentComponent.get("attributes").id;
        window.componentBlocklyCode[componentId] = blockly_code;
        // console.log( "Stored blockly code for component:", componentId, blockly_code );
      }

      // console.log("blockly_code from LB:::::::::", blockly_code);
      try {
        // set readonly from generated
        this.getCodeViewer().setContent(blockly_code);
      } catch (e) {
        // readonly not found.
      }
    },

    /**
     * Syncronize blockly when code changes
     */
    sync() {
      const code = this.getCodeViewer().getContent();
      //parseCode(code);
    },

    /**
     * Evaluate code syntax
     */
    runCode() {
      //console.log("run")
      try {
        const code = this.getCodeViewer().getContent();
        Function('"use strict";' + code)(); // final code
        onRun && onRun();
      } catch (err) {
        console.log("error", err);
        onError && onError(err);
      }
    },

    ...commandBlocklyScript,
  });
};
